import { render } from "./sessionDetail.vue?vue&type=template&id=70aca1f4&scoped=true"
import script from "./sessionDetail.vue?vue&type=script&lang=js"
export * from "./sessionDetail.vue?vue&type=script&lang=js"

import "./sessionDetail.vue?vue&type=style&index=0&id=70aca1f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70aca1f4"]])

export default __exports__